import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 13c0-6.075-4.925-11-11-11S5 6.925 5 13c0 4.22 1.977 8.272 5.245 12.031a33 33 0 0 0 3.545 3.497l.25.21.479.39.444.348.402.3.062.043a1 1 0 0 0 1.146 0l.341-.25.123-.093.444-.347.478-.39.251-.211a33 33 0 0 0 3.545-3.497C25.023 21.272 27 17.22 27 13M7 13a9 9 0 1 1 18 0c0 3.655-1.773 7.29-4.755 10.719a31 31 0 0 1-3.33 3.285l-.235.197-.445.364-.235.185-.235-.185-.446-.364-.116-.097-.604-.522a31 31 0 0 1-2.844-2.863C8.773 20.29 7 16.655 7 13m9-5a5 5 0 1 1 0 10 5 5 0 0 1 0-10m-3 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconMapPin = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconMapPin);
export default Memo;
